export default {"src":"/_next/static/media/site24x7.adf43c7e.svg","height":286,"width":787,"blurWidth":0,"blurHeight":0};